import {globalStores as stores} from '@stores'
import { lockr } from '@api'
export const getAuthHeader = ( method ) => {
  const token = stores?.authStore?.accessToken ?? lockr.get('access_token')
 return {
    method: method,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  }
}


// WEBPACK FOOTER //
// ./src/services/serviceUtils.ts